/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { queryClient } from './Services/API/QueryClient';
import theme from './Config/ThemeConfig';
import 'dayjs/locale/de';
import './Providers/TranslationProvider';
import './App.scss';
import StoreAppFrame from './RootComponents/StoreAppFrame';

const magiclineCheckout = document.querySelector('[data-magicline-checkout]');

if (magiclineCheckout) {
  const root = ReactDOM.createRoot(magiclineCheckout);
  root.render(
    <Suspense fallback={<div>Loading...</div>}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <StoreAppFrame />
          </ThemeProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </Suspense>,
  );
}
